module.exports = __webpack_public_path__ + "images/7e2020c78c234510d69b0dbeefe36bba.jpg";